import { css, type Theme } from "@emotion/react";

import { utilities, helpers, dimensions } from "@styles";

export const input = (theme: Theme) => css`
  ${utilities.transition};
  ${helpers.fontSizeNormalizer(16)};
  color: ${theme.input.textBase};
  border: 1px solid ${theme.input.borderBase};
  border-radius: ${dimensions.borderRadius};

  &::placeholder {
    ${utilities.transition};
    color: ${theme.input.textPlaceholder};
  }

  &:hover {
    border-color: ${theme.input.borderHover};
  }

  &:active,
  &:focus {
    outline: none;
    border-color: ${theme.input.borderActive};

    &::placeholder {
      color: ${theme.input.textBase};
    }
  }
`;

export const disabled = (theme: Theme) => css`
  background-color: ${theme.disabled.inputBackground};
  border-color: ${theme.disabled.border};
  color: ${theme.disabled.inputBackground};

  &::placeholder {
    color: ${theme.disabled.inputLabelText};
  }

  &:hover,
  &:active,
  &:focus {
    background-color: ${theme.disabled.inputBackground};
    color: ${theme.disabled.inputBackground};
    border-color: ${theme.disabled.border};

    &::placeholder {
      color: ${theme.disabled.inputLabelText};
    }
  }
`;

export const sizes = {
  small: css`
    padding: 0.5rem 0.75rem;
  `,
  normal: css`
    padding: 0.75rem 1rem;
  `,
  large: css`
    padding: 1rem 1.5rem;
  `,
};
